<section class="iguau-sugerencias"  aria-labelledby="quizas-titulo">
  <div class="iguau-sugerencias__layout">
    <div class="iguau-sugerencias__intro">
      <div class="iguau-sugerencias__eyebrow"><i class="fa-solid fa-paw" aria-hidden="true"></i> AMIGOS PARA TU MASCOTA</div>

      <h2 id="quizas-titulo">Quizás conozcas...</h2>
      <p>Personas y mascotas con intereses similares que también forman parte de iGuau.</p>
      <div class="iguau-sugerencias__ubicacion" *ngIf="misdatos?.ID && ubicacionBusqueda">
        <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
        Buscando en {{ ubicacionBusqueda }}
      </div>
      <div class="iguau-sugerencias__meta" *ngIf="!busy && !error && perfiles.length">
        <i class="fa-solid fa-users" aria-hidden="true"></i>
        {{ perfiles.length }} {{ perfiles.length === 1 ? 'perfil sugerido' : 'perfiles sugeridos' }} {{ misdatos?.ID ? 'para ti' : 'de la comunidad' }}
      </div>
      <a class="iguau-sugerencias__cta" [href]="global.urlServer + 'perfiles/'">
        Ver más sugerencias <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
      </a>
    </div>

    <div class="iguau-sugerencias__content" [class.iguau-sugerencias__content--private]="misdatos?.perfilPublico === 'no_publico'">
      <div class="iguau-sugerencias__loading" *ngIf="busy" aria-live="polite" aria-label="Cargando perfiles sugeridos">
        <div class="iguau-sugerencias__skeleton" *ngFor="let item of skeletons">
          <div class="iguau-sugerencias__skeleton-photo"></div>
          <div class="iguau-sugerencias__skeleton-line"></div>
          <div class="iguau-sugerencias__skeleton-line short"></div>
        </div>
      </div>

      <div class="iguau-sugerencias__state" *ngIf="!busy && error" role="alert">
        <i class="fa-solid fa-wifi" aria-hidden="true"></i>
        <h3>No se pudieron cargar las sugerencias</h3>
        <p>{{ error }}</p>
        <button type="button" class="iguau-sugerencias__retry" (click)="recargar()">Reintentar</button>
      </div>

      <div class="iguau-sugerencias__slider" *ngIf="!busy && !error && perfiles.length">
        <button type="button" class="iguau-sugerencias__arrow iguau-sugerencias__arrow--prev"
                [disabled]="paginaActual === 0" (click)="cambiarPagina(-1)" aria-label="Perfiles anteriores">
          <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
        </button>
        <div class="iguau-sugerencias__track" #carrusel (scroll)="sincronizarScroll()">
        <a *ngFor="let perfil of perfiles; trackBy: trackByPerfil" class="iguau-sugerencias__card"
           [href]="perfilUrl(perfil)" [attr.aria-label]="'Ver perfil de ' + nombrePersona(perfil)">
          <div class="iguau-sugerencias__photo">
            <img *ngIf="imagenMascota(perfil)" [src]="imagenMascota(perfil)"
                 [alt]="'Fotografía de ' + nombreMascota(perfil)" loading="lazy" decoding="async">
            <div *ngIf="!imagenMascota(perfil)" class="iguau-sugerencias__no-photo">
              <i class="fa-solid fa-paw" aria-hidden="true"></i>
            </div>
            <span class="iguau-sugerencias__favorite" aria-hidden="true"><i class="fa-regular fa-heart"></i></span>
            <span class="iguau-sugerencias__avatar" *ngIf="imagenPerfil(perfil)">
              <img [src]="imagenPerfil(perfil)" [alt]="'Foto de ' + nombrePersona(perfil)" loading="lazy">
            </span>
          </div>
          <div class="iguau-sugerencias__card-body">
            <div class="iguau-sugerencias__pet-name"><span class="iguau-sugerencias__status" aria-hidden="true"></span>{{ nombreMascota(perfil) }}</div>


            <div class="iguau-sugerencias__place" *ngIf="ubicacion(perfil)"><i class="fa-solid fa-location-dot" aria-hidden="true"></i> {{ ubicacion(perfil) }}</div>
            <span class="iguau-sugerencias__view" aria-hidden="true"><i class="fa-solid fa-user-plus"></i></span>
          </div>
        </a>
        </div>
        <button type="button" class="iguau-sugerencias__arrow iguau-sugerencias__arrow--next"
                [disabled]="paginaActual >= totalPaginas - 1" (click)="cambiarPagina(1)" aria-label="Perfiles siguientes">
          <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
        </button>
        <div class="iguau-sugerencias__dots" *ngIf="totalPaginas > 1">
          <button type="button" *ngFor="let pagina of paginas" [class.active]="pagina === paginaActual"
                  (click)="irPagina(pagina)" [attr.aria-label]="'Ver grupo ' + (pagina + 1)"
                  [attr.aria-current]="pagina === paginaActual ? 'true' : null"></button>
        </div>
      </div>

      <div class="iguau-sugerencias__state" *ngIf="!busy && !error && !perfiles.length">
        <i class="fa-solid fa-paw" aria-hidden="true"></i>
        <h3>¡Tu comunidad está creciendo!</h3>
        <p>Todavía no tenemos sugerencias para ti. Explora otros perfiles y descubre nuevos amigos peludos.</p>
        <a [href]="global.urlServer + 'perfiles/'" class="iguau-sugerencias__retry">Explorar perfiles</a>
      </div>
      <div class="iguau-sugerencias__private-note" *ngIf="!busy && misdatos?.perfilPublico === 'no_publico'">
        <i class="fa-solid fa-lock" aria-hidden="true"></i> Tu perfil está configurado como privado.
      </div>
    </div>
  </div>
</section>
